var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionsRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16661",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12479",
    d: "M3.75 11.25V7.5A2.5 2.5 0 016.25 5h17.5a2.5 2.5 0 012.5 2.5v15a2.5 2.5 0 01-2.5 2.5h-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12480",
    d: "M11.25 25l-.314-.787a2.88 2.88 0 00-.72-1.049h0a2.885 2.885 0 00-1.961-.769h-2.76a2.888 2.888 0 00-1.961.769h0a2.88 2.88 0 00-.72 1.049L2.5 25"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12481",
    d: "M8.421 15.641a2.188 2.188 0 11-3.094 0 2.189 2.189 0 013.094 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12482",
    d: "M13.75 18.75v-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12483",
    d: "M17.5 18.75V14.6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12484",
    d: "M21.25 18.75v-1.562"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12485",
    d: "M0 0h30v30H0z",
    fill: "none"
  })));
}
export default SvgSolutionsRight;


//////////////////
// WEBPACK FOOTER
// ./src/icons/SolutionsRight.svg
// module id = 452
// module chunks = 13